<template>
  <CButton class="btn-block btn-google" v-on="$listeners" :text="text">
    <i class="fa fa-google mr-2" />
  </CButton>
</template>

<script>
import CButton from "../partials/CButton";

export default {
  components: {
    CButton,
  },
  data() {
    return {
      text: this.$t("sign_in_dialog.button.google"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/scss/variables";

.btn-google {
  background: $color-google-red;
  color: white;

  &:hover {
    background: darken($color-google-red, 10%);
  }
}
</style>
